(() => {
  const sections = document.querySelectorAll('[data-whyshift-store-locator]');
  if (!sections.length) return;

  sections.forEach((section) => {
    const search = section.querySelector('[data-whyshift-store-search]');
    const items = section.querySelectorAll('[data-whyshift-store-item]');
    const countEl = section.querySelector('[data-whyshift-store-count]');
    const empty = section.querySelector('[data-whyshift-store-empty]');
    if (!search || !items.length) return;

    const resultsLabel = countEl?.textContent?.replace(/^\d+\s*/, '') || 'locations';

    const filter = () => {
      const query = search.value.trim().toLowerCase();
      let visible = 0;

      items.forEach((item) => {
        const text = (item.getAttribute('data-search-text') || item.textContent || '').toLowerCase();
        const match = !query || text.includes(query);
        item.hidden = !match;
        if (match) visible += 1;
      });

      if (countEl) {
        countEl.textContent = `${visible} ${resultsLabel.trim()}`;
      }

      if (empty) {
        empty.hidden = visible > 0 || !query;
      }
    };

    search.addEventListener('input', filter);
  });
})();
